// Train Horn Drill — product page V1 — Shopify-adapted
(function () {
  if (!document.querySelector('.thd-pdp-v1')) return;
  var root = document.querySelector('.thd-pdp-v1');

  // ---------- Gallery
  var stage = root.querySelector('#thd-gallery-stage');
  if (stage) {
    var slides = stage.querySelectorAll('img');
    var dotsEl = root.querySelector('#thd-gallery-dots');
    var thumbsEl = root.querySelector('#thd-thumbs');
    var active = 0;

    if (dotsEl) slides.forEach(function (_, i) {
      var dot = document.createElement('span');
      if (i === 0) dot.classList.add('active');
      dot.addEventListener('click', function () { go(i); });
      dotsEl.appendChild(dot);
    });
    if (thumbsEl) slides.forEach(function (img, i) {
      var b = document.createElement('button');
      if (i === 0) b.classList.add('active');
      // Thumbnails use the small data-thumb image, never the full-size source.
      b.innerHTML = '<img src="' + (img.getAttribute('data-thumb') || img.src) + '" alt="" loading="lazy" width="160" height="160">';
      b.addEventListener('click', function () { go(i); });
      thumbsEl.appendChild(b);
    });
    // Load the full-size image only when its slide is selected.
    function loadFull(i) {
      var img = slides[i];
      if (img && !img.getAttribute('src') && img.getAttribute('data-src')) {
        img.setAttribute('src', img.getAttribute('data-src'));
      }
    }
    function go(i) {
      slides[active].classList.remove('active');
      if (dotsEl && dotsEl.children[active]) dotsEl.children[active].classList.remove('active');
      if (thumbsEl && thumbsEl.children[active]) thumbsEl.children[active].classList.remove('active');
      active = (i + slides.length) % slides.length;
      loadFull(active);
      slides[active].classList.add('active');
      if (dotsEl && dotsEl.children[active]) dotsEl.children[active].classList.add('active');
      if (thumbsEl && thumbsEl.children[active]) thumbsEl.children[active].classList.add('active');
    }
    root.querySelectorAll('.gallery__arrow--prev').forEach(function (b) { b.addEventListener('click', function () { go(active - 1); }); });
    root.querySelectorAll('.gallery__arrow--next').forEach(function (b) { b.addEventListener('click', function () { go(active + 1); }); });

    // Touch swipe
    var gallery = root.querySelector('.gallery');
    if (gallery && 'ontouchstart' in window) {
      var startX = 0, startY = 0, startT = 0, dragging = false;
      var SWIPE_MIN = 40, SWIPE_MAX_T = 600, SWIPE_AXIS_RATIO = 1.4;
      gallery.addEventListener('touchstart', function (e) {
        var t = e.changedTouches[0];
        startX = t.clientX; startY = t.clientY; startT = Date.now();
        dragging = true;
        stage.style.transition = 'none';
      }, { passive: true });
      gallery.addEventListener('touchmove', function (e) {
        if (!dragging) return;
        var t = e.changedTouches[0];
        var dx = t.clientX - startX, dy = t.clientY - startY;
        if (Math.abs(dx) > Math.abs(dy)) {
          var img = slides[active];
          if (img) img.style.transform = 'translateX(' + (dx * 0.4) + 'px)';
        }
      }, { passive: true });
      gallery.addEventListener('touchend', function (e) {
        if (!dragging) return;
        dragging = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - startX, dy = t.clientY - startY, dt = Date.now() - startT;
        slides.forEach(function (s) { s.style.transform = ''; s.style.transition = ''; });
        stage.style.transition = '';
        if (dt > SWIPE_MAX_T) return;
        if (Math.abs(dx) < SWIPE_MIN) return;
        if (Math.abs(dx) < Math.abs(dy) * SWIPE_AXIS_RATIO) return;
        if (dx < 0) go(active + 1); else go(active - 1);
      });
    }
  }

  // ---------- Variant pickers wired to Shopify variants
  // Each .opts__row[data-group="X"] corresponds to a Shopify product option named X.
  function getVariantData() {
    // The data block lives after the .thd-pdp-v1 wrapper, so scope to the
    // whole document — the id is unique.
    var el = document.getElementById('thd-variants-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  var VARIANT_DATA = getVariantData();

  function selectedOptions() {
    var opts = {};
    root.querySelectorAll('.opts__row').forEach(function (row) {
      var group = row.dataset.group;
      var btn = row.querySelector('[data-val].active') || row.querySelector('[data-val]');
      if (btn) opts[group] = btn.dataset.val;
    });
    return opts;
  }

  function findVariant() {
    if (!VARIANT_DATA) return null;
    var selected = selectedOptions();
    var optionNames = VARIANT_DATA.option_names || [];
    return VARIANT_DATA.variants.find(function (v) {
      return optionNames.every(function (name) {
        var sel = selected[name.toLowerCase()] || selected[name];
        return !sel || v.options[name] === sel;
      });
    });
  }

  function setActive(row, btn) {
    row.querySelectorAll('[data-val]').forEach(function (x) { x.classList.remove('active'); });
    btn.classList.add('active');
    var labelTarget = root.querySelector('#opt-' + row.dataset.group);
    if (labelTarget) labelTarget.textContent = btn.dataset.val;
  }

  function updateVariantUI() {
    var v = findVariant();
    if (!v) return;
    var priceCurrent = root.querySelector('.price__current');
    var priceCompare = root.querySelector('.price__compare');
    var priceSave = root.querySelector('.price__save');
    var priceYousave = root.querySelector('.price__yousave');
    var ctaPrimary = root.querySelector('.cta--primary');
    var variantInput = root.querySelector('input[name="id"]');

    var formatMoney = function (cents) { return '$' + Math.round(cents / 100); };
    if (priceCurrent) priceCurrent.textContent = formatMoney(v.price);
    if (priceCompare && v.compare_at_price && v.compare_at_price > v.price) {
      priceCompare.style.display = '';
      priceCompare.textContent = formatMoney(v.compare_at_price);
      var saveAmt = v.compare_at_price - v.price;
      var savePct = Math.round((saveAmt / v.compare_at_price) * 100);
      if (priceSave) { priceSave.style.display = ''; priceSave.textContent = 'SAVE ' + savePct + '%'; }
      if (priceYousave) { priceYousave.style.display = ''; priceYousave.textContent = 'You save ' + formatMoney(saveAmt); }
    } else {
      if (priceCompare) priceCompare.style.display = 'none';
      if (priceSave) priceSave.style.display = 'none';
      if (priceYousave) priceYousave.style.display = 'none';
    }
    if (ctaPrimary) ctaPrimary.disabled = !v.available;
    if (variantInput) variantInput.value = v.id;
    var stickyBtn = document.querySelector('#thd-stickybuy .cta--primary');
    if (!v.available) {
      if (ctaPrimary) ctaPrimary.textContent = 'Sold out';
      if (stickyBtn) stickyBtn.textContent = 'Sold out';
    }
    var stickyPrice = document.querySelector('#thd-stickybuy .stickybuy__info span');
    if (stickyPrice) {
      var html = '';
      if (v.compare_at_price && v.compare_at_price > v.price) html += '<s>' + formatMoney(v.compare_at_price) + '</s> ';
      html += formatMoney(v.price);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        var pct = Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100);
        html += ' <em>SAVE ' + pct + '%</em>';
      }
      stickyPrice.innerHTML = html;
    }
  }

  root.querySelectorAll('.opts__row').forEach(function (row) {
    row.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-val]');
      if (!btn) return;
      setActive(row, btn);
      updateVariantUI();
      if (typeof refreshKitTotal === 'function') refreshKitTotal();
    });
  });

  // ---------- Quantity stepper
  root.querySelectorAll('.qty__btn').forEach(function (b) {
    b.addEventListener('click', function () {
      var input = root.querySelector('#thd-qty');
      if (!input) return;
      var next = Math.max(1, parseInt(input.value || '1', 10) + Number(b.dataset.step));
      input.value = next;
    });
  });

  // ---------- Testimonials carousel
  var tWrap = root.querySelector('#thd-t-carousel');
  var tPrev = root.querySelector('#thd-t-prev');
  var tNext = root.querySelector('#thd-t-next');
  if (tPrev && tWrap) tPrev.addEventListener('click', function () { tWrap.scrollBy({ left: -340, behavior: 'smooth' }); });
  if (tNext && tWrap) tNext.addEventListener('click', function () { tWrap.scrollBy({ left: 340, behavior: 'smooth' }); });

  // ---------- Sticky buy bar
  var stickybuy = document.getElementById('thd-stickybuy');
  var heroBuy = root.querySelector('.hero__buy');
  if (stickybuy && heroBuy) {
    function checkSticky() {
      var rect = heroBuy.getBoundingClientRect();
      if (rect.bottom < 0) stickybuy.classList.add('show');
      else stickybuy.classList.remove('show');
    }
    window.addEventListener('scroll', checkSticky, { passive: true });
    checkSticky();
  }

  // ---------- Customize Your Kit (addons)
  var ctaPrimary = root.querySelector('.cta--primary');
  var stickyBtn = document.querySelector('#thd-stickybuy .cta--primary');

  // Track current selected variant in a closure variable, refreshed on every option click
  window.__thdCurrentVariant = null;
  function refreshCurrentVariant() {
    var v = findVariant();
    if (v) window.__thdCurrentVariant = v;
    return v || (VARIANT_DATA && VARIANT_DATA.variants && VARIANT_DATA.variants[0]) || null;
  }

  function fmtMoney(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }
  function readBasePrice() {
    var v = refreshCurrentVariant();
    if (v && typeof v.price === 'number') return v.price;
    // Fallback: server-rendered base price on the button, so the CTA never shows $0.
    var btn = root.querySelector('.cta--primary[data-base-price]');
    var fallback = btn ? parseInt(btn.dataset.basePrice, 10) : 0;
    return isNaN(fallback) ? 0 : fallback;
  }
  function totalAddons() {
    var sum = 0;
    root.querySelectorAll('.kit__item').forEach(function (it) {
      if (!it.classList.contains('is-active')) return;
      var price = parseInt(it.dataset.price || '0', 10);
      var qtyEl = it.querySelector('.kit__qty-num');
      var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 0;
      if (isNaN(qty)) qty = 0;
      var included = it.dataset.included === '1';
      var billable = included ? Math.max(0, qty - 1) : qty;
      sum += billable * price;
    });
    return sum;
  }
  function refreshKitTotal() {
    var base = readBasePrice();
    var ad = totalAddons();
    var total = base + ad;
    if (ctaPrimary && !ctaPrimary.disabled) ctaPrimary.textContent = 'Add to Cart — ' + fmtMoney(total);
    if (stickyBtn) stickyBtn.textContent = 'Add to Cart — ' + fmtMoney(total);
  }
  root.querySelectorAll('.kit__item').forEach(function (item) {
    var qtyNum = item.querySelector('.kit__qty-num');
    var priceEl = item.querySelector('.kit__price');
    var price = parseInt(item.dataset.price || '0', 10);
    var included = item.dataset.included === '1';

    function updatePrice() {
      var qty = parseInt(qtyNum.textContent, 10) || 0;
      if (included) {
        if (qty <= 1) {
          priceEl.textContent = 'FREE';
          priceEl.classList.add('kit__price--free');
        } else {
          priceEl.textContent = '+' + fmtMoney((qty - 1) * price);
          priceEl.classList.remove('kit__price--free');
        }
      } else if (qty === 0) {
        priceEl.textContent = '+' + fmtMoney(price);
      } else {
        priceEl.textContent = '+' + fmtMoney(qty * price);
      }
    }

    item.addEventListener('click', function (e) {
      if (e.target.closest('.kit__qty-btn')) return;
      if (included) return;
      var nowActive = item.classList.toggle('is-active');
      // Keep the displayed quantity in sync with the active state so the
      // button total, the line price, and what is added to cart all agree.
      var qty = parseInt(qtyNum.textContent, 10) || 0;
      if (nowActive && qty < 1) qtyNum.textContent = '1';
      else if (!nowActive) qtyNum.textContent = '0';
      updatePrice();
      refreshKitTotal();
    });
    item.querySelectorAll('.kit__qty-btn').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        var step = Number(b.dataset.step);
        var min = included ? 1 : 0;
        var qty = parseInt(qtyNum.textContent, 10) + step;
        if (qty < min) qty = min;
        if (qty > 9) qty = 9;
        qtyNum.textContent = qty;
        if (!included) {
          if (qty === 0) item.classList.remove('is-active');
          else item.classList.add('is-active');
        }
        updatePrice();
        refreshKitTotal();
      });
    });
  });
  refreshKitTotal();

  // Intercept add-to-cart to also add active accessory variants
  var pdpForm = root.querySelector('.thd-pdp-form');
  if (pdpForm) {
    pdpForm.addEventListener('submit', function (e) {
      var extras = [];
      root.querySelectorAll('.kit__item.is-active').forEach(function (it) {
        var vid = it.dataset.variantId;
        if (!vid) return;
        var qtyEl = it.querySelector('.kit__qty-num');
        var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 0;
        if (isNaN(qty)) qty = 0;
        var included = it.dataset.included === '1';
        var billable = included ? Math.max(0, qty - 1) : qty;
        if (billable > 0) extras.push({ id: parseInt(vid, 10), quantity: billable });
      });
      if (extras.length === 0) return; // normal submit
      e.preventDefault();
      var formData = new FormData(pdpForm);
      var mainItem = { id: parseInt(formData.get('id'), 10), quantity: parseInt(formData.get('quantity'), 10) || 1 };
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [mainItem].concat(extras) }),
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () { pdpForm.submit(); });
    });
  }

  // ---------- Description collapse/expand
  var descToggles = root.querySelectorAll('[data-thd-collapsible]');
  descToggles.forEach(function(box){
    var btn = box.querySelector('.hero__description-toggle');
    var inner = box.querySelector('.hero__description-inner');
    if (!btn || !inner) return;
    // Hide button if content fits
    if (inner.scrollHeight <= inner.clientHeight + 4) {
      btn.style.display = 'none';
      var afterBox = box.querySelector('.hero__description-inner');
      if (afterBox) afterBox.style.maxHeight = 'none';
      var fade = box.querySelector('.hero__description-inner');
      box.classList.add('is-expanded');
      return;
    }
    btn.addEventListener('click', function(){
      var open = box.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // Initialize
  updateVariantUI();
})();


